import { render, staticRenderFns } from "./PartnershipsGraph.vue?vue&type=template&id=8799f530&scoped=true&"
import script from "./PartnershipsGraph.vue?vue&type=script&setup=true&lang=js&"
export * from "./PartnershipsGraph.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PartnershipsGraph.vue?vue&type=style&index=0&id=8799f530&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8799f530",
  null
  
)

export default component.exports